"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

// TODO: german: (Klassen, Serien, Bauen)
var _default = (0, _reactIntl.defineMessages)({
  class: {
    id: "window.skills.tab.class",
    defaultMessage: "Class",
    description: ""
  },
  combos: {
    id: "window.skills.tab.combos",
    defaultMessage: "Combos",
    description: ""
  },
  crafting: {
    id: "window.skills.tab.crafting",
    defaultMessage: "Crafting",
    description: ""
  }
});

exports.default = _default;